<template>
  <div class="home" v-loading="loading">
    <div class="scroll-content">
      <div class="section slide-one">
        <div class="page">
          <h2>新众鑫仪表</h2>
          <!-- <p>XINZHONGXIN GAUGE</p> -->
        </div>
        <p class="slogan">仪表精工            全球信赖</p>
      </div>

    

       <div class="app-download-section">
        <div class="app-download-content">
          <div class="app-download-text">
            <h2>众鑫云科APP</h2>
            <p>
              所有仪表产品都可以在我们的APP中便捷购买，还可在线定制专属仪表，厂家直销，没有中间商赚差价，价格更优，服务更好！
            </p>
            <p>
              APP内涵盖上百种仪表产品，支持一键下单、批量采购、在线售后、物流跟踪等多项便捷功能。无论您是企业还是个人用户，都能享受高效、透明的采购体验。
            </p>
            <p>
              <strong>专属定制：</strong>可根据您的需求定制各类压力表、温度表等仪表产品，满足不同行业应用。
            </p>
            <p>
              <strong>厂家直销：</strong>所有产品均由浙江新众鑫仪表科技有限公司直接发货，品质保障，售后无忧。
            </p>
            <div class="app-download-btns">
              <div class="download-btn android">
                <img src="@/assets/img/android.png" alt="安卓" />
              
                安卓下载
                <div class="android-qr">
                  <img src="@/assets/img/android_prod.png" alt="安卓APP二维码" />
                  <span>扫码下载安卓APP</span>
                </div>
              </div>
              <a href="https://apps.apple.com/cn/app/your-app-id" class="download-btn ios" target="_blank">
                <img src="@/assets/img/ios.svg" alt="苹果" />
                App Store下载
              </a>
            </div>
          </div>
          <div class="app-download-images">
            <div class="app-img-list">
              <div class="app-img-item"><img src="@/assets/img/app1.jpg" alt="APP截图1" /></div>
              <div class="app-img-item"><img src="@/assets/img/app2.jpg" alt="APP截图2" /></div>
              <div class="app-img-item"><img src="@/assets/img/app3.jpg" alt="APP截图3" /></div>
              <div class="app-img-item"><img src="@/assets/img/app4.jpg" alt="APP截图4" /></div>
              <div class="app-img-item"><img src="@/assets/img/app5.jpg" alt="APP截图5" /></div>
            </div>
          </div>
        </div>
    </div>

    
      <div class="section slide-two">
        <div class="page">
          <h1>产品类别</h1>
          <!-- <p>Product Categories</p> -->
        </div>
        <ul class="product-category-list">
          <li>
            <img src="@/assets/img/category1.jpg" alt="耐震压力表" class="category-img" />
            <span>耐震压力表</span>
          </li>
          <li>
            <img src="@/assets/img/category2.jpg" alt="冷媒表" class="category-img" />
            <span>冷媒表</span>
          </li>
          <li>
            <img src="@/assets/img/category3.jpg" alt="不锈钢压力表" class="category-img" />
            <span>不锈钢压力表</span>
          </li>
          <li>
            <img src="@/assets/img/category4.jpg" alt="膜盒压力表(微压表)" class="category-img" />
            <span>膜盒压力表(微压表)</span>
          </li>
          <li>
            <img src="@/assets/img/category5.jpg" alt="胎压表" class="category-img" />
            <span>胎压表</span>
          </li>
          <li>
            <img src="@/assets/img/category6.jpg" alt="膜片式压力表(耐跌落)" class="category-img" />
            <span>膜片式压力表(耐跌落)</span>
          </li>
        </ul>
      </div>
      <div class="section slide-three">
        <div class="page">
          <h1>公司概况</h1>
          <p class="company-desc1">
            “用户至上，质量第一”是浙江新众鑫仪表科技有限公司的企业信念。公司成立以来一直坚持不断创新的理念，为不同的客户提供不同种类的压力表：各种空气压缩机压力表、轮胎胎压表、油管、石化、食品机械用不锈钢充油表、数显表、膜盒表（微压表）、膜片表、消防表、毛细管表。公司拥有高效、稳定、务实的技术团队，竭诚为每一位客户提供专业服务。
            <br />
            <!-- <strong>我们做什么</strong><br />
            新众鑫仪表科技是领先的压力表制造商，为不同客户提供各种空气压缩机压力表、轮胎胎压表、油管、石化、食品机械用不锈钢充油表、数显表、膜盒表（微压表）、膜片表、消防表、毛细管表等不同种类的压力表。 -->
          </p>
        </div>
      </div>
    </div>





    <footer class="footer">
      <div class="footer-main">
        <div class="footer-section">
          <h4>关注我们</h4>
          <p>© 浙江新众鑫仪表科技有限公司 保留所有权利</p>
          <p>Design by <a href="http://zxykapp.com" target="_blank" style="color:#ffd700;">zjzxyb.com</a></p>
        </div>
        <div class="footer-section">
          <h4>联系我们</h4>
          <p>地址：浙江省台州市仙居县白塔工业聚集区桐江路42-2号</p>
          <p>电话：0086-576-88341510</p>
          <p>传真：0086-576-88341510</p>
          <p>邮箱：<a href="mailto:sales@zjzxyb.com" style="color:#ffd700;">sales@zjzxyb.com</a></p>
        </div>
      </div>
      <div class="icp" style="text-align:center;margin-top:18px;">
        <a href="https://beian.miit.gov.cn" target="_blank" style="color:#ffd700;text-decoration:underline;">
          浙ICP备2025175289号-1
        </a>
  </div>
</footer>
  </div>
</template>
 
<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      loading: false
    };
  }
};
</script>
 
<style lang="scss" scoped>
.home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.scroll-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  
}
.section {
  width: 100%;
  margin: 0 auto;
  padding: 60px 0 0 0;
}
.icp {
  text-align: center;
  margin-top: 18px;
  font-size: 16px;
  a {
    color: #ffd700;
    text-decoration: underline;
  }
}


.slide-one .page h2 {
  color: #fff;
  font-size: 56px;
  font-weight: 700;
  letter-spacing: 2px;
  text-shadow: 0 2px 12px rgba(0,0,0,0.18);
}

.slide-one .page h3 {
  color: #fff;
  font-size: 56px;
  font-weight: 700;
  letter-spacing: 2px;
  text-shadow: 0 2px 12px rgba(0,0,0,0.18);
}

.slogan {
    color: #fff;
    font-size: 36px;
    font-weight: 700;
    letter-spacing: 2px;
    text-shadow: 0 2px 12px rgba(0,0,0,0.18);
  }


.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    // height: 100px;
    // overflow: hidden;
    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}
//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
  text-align: center;
  min-height: 520px; // 增加最小高度，数值可根据实际效果调整
  margin-bottom: 0;
  padding-bottom: 60px; // 增加底部内边距，形成与下一区域的自然过渡

  .page {
    margin-top: 260px;
  }
  
}
.slide-two {
  position: relative;
  background: none;
  text-align: center;
  padding: 60px 0 60px 0; // 增加上下内边距
}
.slide-two::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
  filter: blur(8px);
  z-index: 0;
}
.slide-two .page,
.slide-two .product-category-list {
  position: relative;
  z-index: 1;
  filter: none;
}

.slide-two .page h1 {
  color: #222;
  // text-shadow: 1px 1px 6px #222, 0 0 10px #000;
}

.slide-two .page h3 {
  color: #222;
  text-shadow: 1px 1px 6px #222, 0 0 10px #000;
}
.slide-three {
  position: relative;
  min-height: 600px; // 增加最小高度，可根据需要调整数值
  padding-bottom: 60px; // 增加底部内边距，避免内容贴底
}
.slide-three::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
  opacity: 1;
  z-index: 0;
}
.slide-three .page {
  text-align: center;
  margin-top: 120px;
}
.slide-three .page, .slide-three .company-desc {
  position: relative;
  z-index: 2;
}
//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
// 产品类别样式
.product-category-list {
  width: 100%;
  max-width: 1240px;
  margin: 40px auto 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px 32px;
  list-style: none;
  padding: 0;
  li {
    width: 320px;
    height: 390px;
    background: linear-gradient(135deg, #232f3e 80%, #3a4a5d 100%);
    color: #fff;
    font-size: 28px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.10);
    transition: box-shadow 0.2s;
  }
  li:hover {
    box-shadow: 0 8px 32px rgba(225,56,52,0.25);
  }
}
.category-img {
  width: 300px;
  height: 300px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 18px;
}
.product-category-list span {
  font-size: 24px;
  font-weight: 500;
  color: #fff;
  margin-top: 12px;
}
.slide-two .page,
.slide-two .product-category-list {
  position: relative;
  z-index: 1;
  filter: none;
}
.company-desc1 {
  color: #fff; // 文字改为白色，适配深色背景
  background: rgba(35,47,62,0.85);
  max-width: 900px;
  margin: 40px auto 0 auto;
  font-size: 20px;
  border-radius: 12px;
  padding: 32px 36px;
  line-height: 1.8;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  text-align: left;
  position: relative;
  z-index: 2;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif; // 更适合中文正文
  letter-spacing: 0.5px;
  word-break: break-all;
}
.company-desc1 strong {
  color: #ffd700;
  font-size: 22px;
  display: inline-block;
  margin: 18px 0 8px 0;
}
.company-desc strong {
  color: #ffd700;
  font-size: 24px;
  display: inline-block;
  margin: 18px 0 8px 0;
}

.footer {
  width: 100%;
  background: #232f3e;
  color: #fff;
  padding: 32px 0 20px 0;
  // margin-top: 60px;
  font-size: 16px;
  .footer-main {
    max-width: 1240px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    gap: 40px;
  }
  .footer-section {
    min-width: 260px;
    margin-bottom: 12px;
    h4 {
      color: #ffd700;
      font-size: 20px;
      margin-bottom: 12px;
      font-weight: 600;
    }
    p {
      margin: 4px 0;
      color: #fff;
      font-size: 16px;
      line-height: 1.7;
      a {
        color: #ffd700;
        text-decoration: underline;
      }
    }

    
  }
}

.app-download-section {
  width: 100%;
  background: linear-gradient(135deg, #23344a 60%, #2e4158 100%);
  padding: 80px 0 80px 0;
  min-height: 1200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;         // 保证顶部无外边距
  padding-top: 0;
}
.app-download-content {
  max-width: 1400px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 0;         // 保证顶部无外边距
  padding-top: 0;  
  // gap: 60px;
}
.app-download-text {
  margin-top: 0;         // 保证顶部无外边距
  padding-top: 0;
  flex: 1 1 480px;
  color: #fff;
  h2 {
    color: #ffd700;
    font-size: 38px;
    margin-bottom: 24px;
    font-weight: 700;
    letter-spacing: 1px;
  }
  p {
    font-size: 22px;
    line-height: 1.8;
    margin-bottom: 16px;
  }
  strong {
    color: #ffd700;
    font-weight: 600;
  }
  .app-download-btns {
    margin-top: 32px;
    display: flex;
    gap: 32px;
    .download-btn {
      display: flex;
      align-items: center;
      gap: 10px;
      background: #ffd700;
      color: #23344a;
      font-size: 20px;
      font-weight: 600;
      border-radius: 8px;
      padding: 14px 32px;
      text-decoration: none;
      box-shadow: 0 2px 12px rgba(0,0,0,0.10);
      transition: background 0.2s, color 0.2s;
      position: relative;
      img {
        width: 32px;
        height: 32px;
      }
      &:hover {
        background: #fff;
        color: #1a2636;
      }
    }
    .android {
      cursor: pointer;
      &:hover .android-qr {
        display: flex;
      }
      .android-qr {
        display: none;
        flex-direction: column;
        align-items: center;
        position: absolute;
        top: 60px;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 4px 24px rgba(0,0,0,0.12);
        padding: 18px 18px 10px 18px;
        z-index: 10;
        img {
          width: 120px;
          height: 120px;
          margin-bottom: 8px;
        }
        span {
          color: #23344a;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
    .ios img {
      filter: grayscale(0.2);
    }
  }
}
.app-download-images {
  flex: 1 1 700px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-img-list {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
}
.app-img-item {
  width: 220px;
  height: 440px;
  background: #fff2;
  border: 4px solid #ffd700;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(34,52,74,0.18);
  transition: border-color 0.2s, box-shadow 0.2s;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  &:hover {
    border-color: #fff;
    box-shadow: 0 12px 48px rgba(255,215,0,0.18);
  }


}

.slide-three .page h1 {
    color: #fff;
    font-size: 42px;
    font-weight: 700;
    letter-spacing: 2px;
    text-align: center;
    text-shadow: 0 2px 12px rgba(0,0,0,0.18);
  }
</style>